<template>
    <div class="resource flex flex-vertical-center" @click="handleClick">
        <img :src="extensions[type]" :alt="type" class="type-icon" />
        <div class="flex-item resource-name">{{ name }}</div>
        <img src="@images/player/download.png" alt="下载" class="download-icon" />
    </div>
</template>

<script>
import dirIcon from '@images/file-type/dir.png';
import wordIcon from '@images/file-type/word.png';
import pptIcon from '@images/file-type/ppt.png';

export default {
    name: 'Resource',
    props: {
        type: {
            type: String,
            validator: (val) => ['file', 'pdf', 'word', 'ppt', 'image', 'dir'].includes(val),
            default: 'file'
        },
        name: {
            type: String,
            required: true
        }
    },
    data() {
        const extensions = {
            file: dirIcon,
            pdf: dirIcon,
            ppt: pptIcon,
            word: wordIcon,
            image: dirIcon,
            dir: dirIcon
        };
        return {
            extensions: Object.freeze(extensions)
        };
    },
    methods: {
        handleClick() {
            this.$emit('click');
        }
    }
};
</script>

<style lang="scss" scoped>
.resource {
    background: #2b2b2d;
    border-radius: 10px;
    font-weight: 500;
    color: #999798;
    font-size: 12px;
    padding: 17px 18px;
    &-name {
        margin: 0 10px;
    }
}
.type-icon {
    width: 20px;
    height: 18px;
    object-fit: contain;
}
.download-icon {
    width: 18px;
    height: 14px;
    object-fit: contain;
    cursor: pointer;
}
</style>
